import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  contentType: 'text',
  fromName: '',
  cc: '',
  bcc: '',
  replyTo: '',
  textContent: '',
  htmlContent: '',
  attachments: '',
};

export default defaults;
